import { z } from "zod";
const AnyRecord = z.record(z.any());
const NpmPackageVersionDist = AnyRecord.and(z.object({
    tarball: z.string(),
}));
const NpmPackageVersion = AnyRecord.and(z.object({
    dist: NpmPackageVersionDist,
}));
export const NpmPackage = AnyRecord.and(z.object({
    _id: z.string(),
    name: z.string(),
    // e.g. "latest": "1.2.3"
    "dist-tags": z.record(z.string(), z.string()),
    // "1.2.3": {...}
    versions: z.record(NpmPackageVersion),
}));
